'use client';

import { Typography, Box } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { useRouter } from 'next/navigation';

import { ContentInfoProps } from '../types';

const ContentInfo = ({ title, category, categoryUrl }: ContentInfoProps) => {
  const router = useRouter();

  return (
    <Box className="flex flex-col gap-1 desktop:gap-2">
      <Typography
        variant="subTitle1"
        className={twJoin(
          'line-clamp-2 break-keep font-bold text-w-white',
          'tablet:typo-title3',
          'desktop:text-[28px] desktop:leading-[40px]' // 랜딩 캐러셀 제목 typo-title2.5 토큰으로 적용
        )}
      >
        {title}
      </Typography>
      <button
        onClick={(e) => {
          e.preventDefault();
          router.push(categoryUrl);
        }}
        className="w-fit"
      >
        <Typography variant="body1" className="text-w-white/80 hover:underline">
          {category}
        </Typography>
      </button>
    </Box>
  );
};

export default ContentInfo;
